import type { MenuIcon } from '@/types/menu';
import { BillingIcon, StoresIcon } from '@/components/Sidebar/icon';
import { Building2, ClipboardList, FileClock, Package, Settings2, Users } from 'lucide-react';
import { RiCoupon2Line } from 'react-icons/ri';
import { MdOutlinePayments } from 'react-icons/md';

const DEFAULT_ICON: MenuIcon = Settings2;

// Map icon "codes" from `/api/v1/menus` to real React icon components.
// Prefer mapping by `icon` string, fallback by route when needed.
const ICON_CODE_MAP: Record<string, MenuIcon> = {
  'icon-dashboard': StoresIcon,
  'icon-customers': Users,
  'icon-companies': Building2,
  'icon-orders': ClipboardList,
  'icon-invoices': BillingIcon,
  'icon-coupons': RiCoupon2Line,
  'icon-payment-settings': MdOutlinePayments,
  'icon-catalog': Package,
  'icon-form-fields': Settings2,
  'icon-notifications': Settings2,
  'icon-audit': FileClock,
};

const ROUTE_ICON_MAP: Record<string, MenuIcon> = {
  '/admin/payment-settings': MdOutlinePayments,
};

export const resolveMenuIcon = (params?: { icon?: string | null; route?: string | null }): MenuIcon => {
  const code = (params?.icon || '').trim();
  if (code && ICON_CODE_MAP[code]) return ICON_CODE_MAP[code];

  const route = (params?.route || '').trim();
  if (route && ROUTE_ICON_MAP[route]) return ROUTE_ICON_MAP[route];

  return DEFAULT_ICON;
};

